import { CalendarIconProps } from '../interfaces/CattlePoCalendarInterface';

const CalendarIcon = (props: CalendarIconProps) => {
    return (
        <img {...props} alt="calendar.png" src={require('./calendar.png')} />
    );
};

export default CalendarIcon;
